(function () {
	const blockquoteSlider = () => {
		$(".blockquote-slider").each(function () {
			if ($(this).hasClass("slider_started")) {
				return "";
			}
			if($(".blockquotes").hasClass("blockquotes__slide-show")){
				$(this).addClass("slider_started");
			}
			const blockquotesId = $(this).data("blockquotes-id");
			const blockquotesSpeed = $(this).data("blockquotes-speed") * 1000;
			const blockquotesSwiper = new Swiper(
				`.blockquote-js-${blockquotesId}`,
				{
					slidesPerView: 1,
					//speed: blockquotesSpeed,
                    autoplay: {
                        delay: 5000,
                    },
					loop: true,
					allowTouchMove: true,
					waitForTransition: false,
					watchSlidesProgress: false,
                    keyboard: true,
                    spaceBetween: 30,
                    freeMode: false,
                    navigation: {
                        nextEl: ".swiper-button-next",
                        prevEl: ".swiper-button-prev",
                    }
				}
			);
		});
	};
	checkWindow();
	$(window).resize(function () {
		checkWindow();
	});
	blockquoteSlider();
	document.addEventListener("shopify:section:load", function () {
		blockquoteSlider();
	});

	document.addEventListener("visibilitychange", function () {
		if (!document.hidden) {
			$(".blockquote-js").each(function () {
				this.swiper.destroy();
			});
			blockquoteSlider();
		}
	});

	function checkWindow() {
		if ($(window).width() < 576) {
			$(".blockquotes").addClass("blockquotes__slide-show");
			blockquoteSlider();
		} else {
			$(".blockquote-slider").removeClass("slider_started");
			$(".blockquotes").removeClass("blockquotes__slide-show");
		}
	}
})();
